/* eslint-disable arrow-body-style */
import Vuetify from '@/plugins/vuetify';
import { formatarMilhares, formatarNumeroDeQuantidade } from '@/utils';
import { formatDate } from '@/utils/tableColumns';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  incentivosFiscais: [],
  colunasIncentivoFiscal: [
    {
      field: 'referenciaCliente',
      maxWidth: 300,
      minWidth: 200,
      headerName: Vuetify.framework.lang.t('$vuetify.referenciaCliente'),
      comparator: () => false,
      tooltipField: 'referenciaCliente',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'referenciaCliente',
        },
      },
    },
    {
      field: 'referenciaInterna',
      maxWidth: 300,
      minWidth: 200,
      headerName: Vuetify.framework.lang.t('$vuetify.referenciaTrust'),
      comparator: () => false,
      tooltipField: 'referenciaInterna',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'referenciaInterna',
        },
      },
    },
    {
      field: 'numeroNotaFiscal',
      maxWidth: 200,
      minWidth: 200,
      headerName: Vuetify.framework.lang.t('$vuetify.numeroNota'),
      comparator: () => false,
      tooltipField: 'numeroNotaFiscal',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'numeroNotaFiscal',
        },
      },
    },
    {
      field: 'dataCadastro',
      maxWidth: 120,
      minWidth: 120,
      headerName: Vuetify.framework.lang.t('$vuetify.Data'),
      valueFormatter: ({ data }) => ((data.dataCadastro) ? formatDate(data.dataCadastro) : 'N/I'),
      comparator: () => false,
      tooltipField: 'dataCadastro',
      filter: 'DateFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'dataCadastro',
        },
      },
    },
    {
      field: 'codigoProduto',
      maxWidth: 180,
      minWidth: 180,
      headerName: Vuetify.framework.lang.t('$vuetify.codigoProduto'),
      comparator: () => false,
      tooltipField: 'codigoProduto',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'codigoProduto',
        },
      },
    },
    {
      field: 'descricaoProduto',
      maxWidth: 500,
      minWidth: 400,
      headerName: Vuetify.framework.lang.t('$vuetify.descricaoProduto'),
      comparator: () => false,
      tooltipField: 'descricaoProduto',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'descricaoProduto',
        },
      },
    },
    {
      field: 'quantidadeProduto',
      maxWidth: 150,
      minWidth: 150,
      headerName: Vuetify.framework.lang.t('$vuetify.quantidade'),
      valueFormatter: ({ data }) => ((data.quantidadeProduto) ? formatarNumeroDeQuantidade(data.quantidadeProduto) : 'N/I'),
      comparator: () => false,
      tooltipField: 'quantidadeProduto',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'quantidadeProduto',
        },
      },
    },
    {
      field: 'unidadeMedida',
      maxWidth: 200,
      minWidth: 300,
      headerName: Vuetify.framework.lang.t('$vuetify.unidadeMedida'),
      comparator: () => false,
      tooltipField: 'unidadeMedida',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'unidadeMedida',
        },
      },
    },
    {
      field: 'valor',
      maxWidth: 250,
      minWidth: 250,
      headerName: Vuetify.framework.lang.t('$vuetify.valorNota'),
      valueFormatter: ({ data }) => ((data.valor) ? formatarMilhares(data.valor) : 'N/I'),
      comparator: () => false,
      tooltipField: 'valor',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'valor',
        },
      },
    },
    {
      field: 'codigoDI',
      maxWidth: 250,
      minWidth: 250,
      headerName: Vuetify.framework.lang.t('$vuetify.declaracaoImportacao'),
      valueFormatter: ({ data }) => ((data.codigoDI) ? data.codigoDI : 'N/I'),
      comparator: () => false,
      tooltipField: 'codigoDI',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'codigoDI',
        },
      },
    },
    {
      field: 'icmsPago',
      maxWidth: 200,
      minWidth: 180,
      headerName: Vuetify.framework.lang.t('$vuetify.icmsPago'),
      valueFormatter: ({ data }) => ((data.icmsPago) ? formatarMilhares(data.icmsPago) : 'N/I'),
      comparator: () => false,
      tooltipField: 'icmsPago',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'icmsPago',
        },
      },
    },
    {
      field: 'descontoIcmsPago',
      maxWidth: 200,
      minWidth: 180,
      headerName: Vuetify.framework.lang.t('$vuetify.descontoIcmsPago'),
      valueFormatter: ({ data }) => ((data.descontoIcmsPago) ? data.descontoIcmsPago.toFixed(3) : 'N/I'),
      comparator: () => false,
      tooltipField: 'descontoIcmsPago',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'descontoIcmsPago',
        },
      },
    },
    {
      field: 'formaDesconto',
      maxWidth: 200,
      minWidth: 200,
      headerName: Vuetify.framework.lang.t('$vuetify.formaDesconto'),
      comparator: () => false,
      tooltipField: 'formaDesconto',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'formaDesconto',
        },
      },
    },
    {
      field: 'situacao',
      maxWidth: 150,
      minWidth: 150,
      headerName: Vuetify.framework.lang.t('$vuetify.situacao'),
      comparator: () => false,
      tooltipField: 'situacao',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'situacao',
        },
      },
    },
    {
      field: 'pctBaseCliente',
      maxWidth: 180,
      minWidth: 180,
      headerName: Vuetify.framework.lang.t('$vuetify.pctCliente'),
      valueFormatter: ({ data }) => ((data.pctBaseCliente) ? data.pctBaseCliente.toFixed(2) : 'N/I'),
      comparator: () => false,
      tooltipField: 'pctBaseCliente',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'pctBaseCliente',
        },
      },
    },
    {
      field: 'pctCliente',
      maxWidth: 180,
      minWidth: 180,
      headerName: Vuetify.framework.lang.t('$vuetify.porcentagemCliente'),
      valueFormatter: ({ data }) => ((data.pctCliente) ? data.pctCliente.toFixed(3) : 'N/I'),
      comparator: () => false,
      tooltipField: 'pctCliente',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'pctCliente',
        },
      },
    },
    {
      field: 'valorCliente',
      maxWidth: 200,
      minWidth: 200,
      headerName: Vuetify.framework.lang.t('$vuetify.valorCliente'),
      valueFormatter: ({ data }) => ((data.valorCliente) ? formatarMilhares(data.valorCliente) : 'N/I'),
      comparator: () => false,
      tooltipField: 'valorCliente',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'valorCliente',
        },
      },
    },
    {
      field: 'tipoImportacao',
      maxWidth: 250,
      minWidth: 250,
      headerName: Vuetify.framework.lang.t('$vuetify.Tipo Importação'),
      comparator: () => false,
      tooltipField: 'tipoImportacao',
      filter: 'TextFilter',
      filterParams: {
        module: 'incentivoFiscal',
        fetch: 'fetchIncentivosFiscais',
        colDef: {
          field: 'tipoImportacao',
        },
      },
    },
  ],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    processo: '',
    dataCadastro: '',
    icmsPago: '',
    pctBaseCliente: '',
    pctEmpresa: '',
    pctCliente: '',
    valorCliente: '',
    numeroNotaFiscal: null,
    codigoProduto: null,
    descricaoProduto: '',
    quantidadeProduto: null,
    unidadeMedida: '',
    valor: null,
    tipoImportacao: '',
    codigoDI: '',
  },
};
